<template>
    <div class="compatibility-list">
        <ul class="list-none inline">
            <li>
                <img :src="'/images/icons/lighting-ico-' + (compatibility.lighting ? 'on' : 'off') + '.svg'"
                    type="image/svg+xml"
                    class="lighting"
                    :class="{compatible: compatibility.lighting, uncompatible: !compatibility.lighting}"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Lighting"
                    data-original-title="Lighting"
                >
            </li>
            <li>
                <img
                    :src="'/images/icons/wifi-ico-' + (compatibility.wifi ? 'on' : 'off') + '.svg'"
                    type="image/svg+xml"
                    class="wifi"
                    :class="{compatible: compatibility.wifi, uncompatible: !compatibility.wifi}"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Wifi"
                    data-original-title="Wifi"
                >
            </li>
            <li>
                <img
                    :src="'/images/icons/bluetooth-ico-' + (compatibility.bluetooth ? 'on' : 'off') + '.svg'"
                    type="image/svg+xml"
                    class="bluetooth"
                    :class="{compatible: compatibility.bluetooth, uncompatible: !compatibility.bluetooth}"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Bluetooth"
                    data-original-title="Bluetooth"
                >
            </li>
            <li>
                <img
                    :src="'/images/icons/fan-ico-' + (compatibility.fanControl ? 'on' : 'off') + '.svg'"
                    type="image/svg+xml"
                    class="fan"
                    :class="{compatible: compatibility.fanControl, uncompatible: !compatibility.fanControl}"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Fan Control"
                    data-original-title="Fan Control"
                >
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "CompatibilityIcons",
    props: {
        build: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            compatibility: {
                lighting: false,
                wifi: false,
                bluetooth: false,
                fanControl: false
            }
        }
    },
    created() {
        Object.keys(this.build).forEach(key => {
            this.check(this.build[key]);
        });
    },
    mounted() {
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover',
            html: true,
            template: '<div class="tooltip help-compatible" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        });
    },
    methods: {
        check(product) {
            if (Array.isArray(product)) {
                product.forEach(item => {
                    this.check(item);
                });
            } else {
                this.compatibility.lighting = this.compatibility.lighting || product.cam_lighting == 1;
                this.compatibility.wifi = this.compatibility.wifi || product.wifi == 1;
                this.compatibility.fanControl = this.compatibility.fanControl || product.fan_control == 1;
                this.compatibility.bluetooth = this.compatibility.bluetooth || product.bluetooth == 1;
            }
        }
    }
}
</script>
